import { render, staticRenderFns } from "./BidOpportunityCell.vue?vue&type=template&id=212f0ca6&scoped=true"
import script from "./BidOpportunityCell.vue?vue&type=script&lang=js"
export * from "./BidOpportunityCell.vue?vue&type=script&lang=js"
import style0 from "./BidOpportunityCell.vue?vue&type=style&index=0&id=212f0ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f0ca6",
  null
  
)

export default component.exports